// extracted by mini-css-extract-plugin
export default {"basic":"MainButton_basic__DabPz","xsmall":"MainButton_xsmall__Mgzs+","small":"MainButton_small__8KBit","medium":"MainButton_medium__tt74b"};